var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 34,
    viewBox: "0 0 40 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1187 16.1001L17.7777 9.53814C17.9492 9.36917 18.0455 9.13999 18.0455 8.90102C18.0455 8.66206 17.9492 8.43288 17.7777 8.2639C17.6063 8.09493 17.3738 8 17.1314 8C16.8889 8 16.6564 8.09493 16.485 8.2639L8.26822 16.3629C8.1832 16.4465 8.11574 16.5458 8.06972 16.6551C8.02369 16.7644 8 16.8816 8 17C8 17.1184 8.02369 17.2356 8.06972 17.3449C8.11574 17.4542 8.1832 17.5535 8.26822 17.6371L16.485 25.7361C16.6564 25.9051 16.8889 26 17.1314 26C17.3738 26 17.6063 25.9051 17.7777 25.7361C17.9492 25.5671 18.0455 25.3379 18.0455 25.099C18.0455 24.86 17.9492 24.6308 17.7777 24.4619L11.1187 17.8999H31.087C31.3292 17.8999 31.5614 17.8051 31.7326 17.6363C31.9038 17.4676 32 17.2387 32 17C32 16.7613 31.9038 16.5324 31.7326 16.3637C31.5614 16.1949 31.3292 16.1001 31.087 16.1001H11.1187Z",
    fill: "#77A600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.c9696a387ce42d60951cdba844d61005.svg";
export { ForwardRef as ReactComponent };